import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;
declare var Dropzone: any;

export class signupFormEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Signup Form</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Info</strong>
                </div>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group row">
                        <label for="idForm" class="form-label form-label form-label-box">Form ESP ID</label>
                        <input type="text" class="input-text" data-bind="value: idForm">
                    </div>
                    <div class="form-group row">
                        <label for="label" class="form-label form-label form-label-box">Form Internal Name</label>
                        <input type="text" class="input-text" data-bind="value: label">
                    </div>
                    <div class="form-group row">
                        <label for="buttonText" class="form-label form-label form-label-box">Form Button Text</label>
                        <input type="text" class="input-text" data-bind="value: buttonText">
                    </div>
                </div>
                <div class="form-body">
                </div>
            </div>
            
            <div class="w-form-body" style="margin-top: -1.25rem"> 
                <div class="form-body" style="position: relative;">
                    <strong class="form-sub-title">Fields</strong>
                    <button id="add_field" class="form-section-btn icon i-plus" data-bind="event: {click: onClickAddField}" type="button"></button>
                    <div id="field_section" class="form-group field">        
                        <table id="field_list" class="list-action full-width" >
                            <thead>
                                <tr style="background-color: #8a8a8a">
                                    <th><span>Label (ESP ID)</span></th>
                                    <th><span>Is Required</span></th>
                                    <th><span>Default Value</span></th>
                                    <th style="width: 10rem;"><span>Action</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: fields">
                                <tr>
                                    <td><span data-bind="text: labelID"></span></td>
                                    <td><span data-bind="text: isRequired"></span></td>
                                    <td><span data-bind="text: defaultValue"></span></td>
                                    <td class="w-btn align-center">
                                        <button type="button" class="btn-form icon icon-only i-edit" data-bind="event: {click: $parent.onClickEditField.bind($index) }"></button>
                                        <button type="button" class="btn-form icon icon-only highlight i-delete" data-bind="event: {click: $parent.onClickDeleteField.bind($index) }"></button>
                                    </td>  
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group" data-bind="visible: fields().length == 0"><p class="form-text">No fields added</p></div>
                    </div>
               </div>
               <div class="form-body" style="position: relative;">
                    <strong class="form-sub-title">Mailing Lists</strong>
                    <button id="add_mailing_list" class="form-section-btn icon i-plus" data-bind="event: {click: onClickAddMailingList}" type="button"></button>
                    <div id="mailing_list_section" class="form-group mailing_list">        
                        <table id="mailing_list" class="list-action full-width" >
                            <thead>
                                <tr style="background-color: #8a8a8a">
                                    <th><span>Label (ESP ID)</span></th>
                                    <th><span>Is Selected by Default</span></th>
                                    <th><span>Description</span></th>
                                    <th><span>Image</span></th>
                                    <th style="width: 10rem;"><span>Action</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: mailingLists">
                                <tr>
                                    <td><span data-bind="text: labelID"></span></td>
                                    <td><span data-bind="text: isSelected"></span></td>
                                    <td><span data-bind="text: description"></span></td>
                                    <td class="small-img">
                                        <span><img data-bind="attr: { src: image }, visible: image"></span>
                                        <span data-bind="text: 'False', visible: !image"></span>
                                    </td>
                                    <td class="w-btn align-center">
                                        <button type="button" class="btn-form icon icon-only i-edit" data-bind="event: {click: $parent.onClickEditMailingList.bind($index) }"></button>
                                        <button type="button" class="btn-form icon icon-only highlight i-delete" data-bind="event: {click: $parent.onClickDeleteMailingList.bind($index) }"></button>
                                    </td>   
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group" data-bind="visible: mailingLists().length == 0"><p class="form-text">No mailing lists added</p></div>
                    </div>
               </div>
           </div>         
            
            <div class="form-footer">                
               <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
               <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div>
            
            <div data-bind="css: { 'is-visible': isAddFieldVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:40rem;">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: menuTitle"></h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCancelField }"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group row">
                                <input type="checkbox" data-bind="checked: isRequired" id="isRequired">
                                <label for="isRequired" class="form-label icon i-check" for="isRequired">Is Required</label>  
                            </div>
                            <div class="form-group">
                                <hr class="form">
                            </div>
                            <div class="form-group row">
                                <label class="form-label">Fields</label>
                                <select id="" data-bind="options: availableFields, optionsText: 'labelID', optionsCaption: 'Select', value: selectedField, optionsValue: 'id', valueAllowUnset: true, event: { change: onChangeField }"></select>
                            </div>
                            
                            <div class="form-group row" data-bind="visible: !isDefaultValueCheckbox()">
                                <label class="form-label">Default Value</label>
                                <input type="text" class="input-text" data-bind="value: defaultValue">
                            </div>
                            <div class="form-group row" data-bind="visible: isDefaultValueCheckbox()">
                                <input type="checkbox" data-bind="checked: defaultValue" id="defaultValue">
                                <label for="defaultValue" class="form-label icon i-check" for="defaultValue">Default Value</label> 
                            </div>
                         </div>
                        <div class="form-footer"> 
                            <button type="button" data-bind="event: { click: onClickCancelField }" class="btn ">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSaveField }" class="btn highlight">Apply</button>
                        </div>
                    </div>
                </div>
            </div>
             
            <div data-bind="css: { 'is-visible': isAddMailingListVisible }" class="w-lightbox light-theme">
               <div class="lightbox-content">
                   <div class="w-form lightbox-form" style="width:40rem;">
                       <div class="form-header">
                           <h3 class="form-title" data-bind="text: menuTitle"></h3>
                           <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCancelMailingList }"></button>
                       </div>
                       <div class="form-body">
                            <div class="form-group row">
                               <input type="checkbox" data-bind="checked: isSelected" id="isSelected">
                               <label for="isSelected" class="form-label icon i-check" for="isSelected">Is Selected by Default</label>  
                           </div>
                           <div class="form-group">
                                <hr class="form">
                            </div>
                           <div class="form-group row">
                               <label class="form-label">Mailing Lists</label>
                               <select id="" data-bind="options: availableMailingLists, optionsText: 'labelID', optionsCaption: 'Select', value: selectedMailingList, optionsValue: 'id', valueAllowUnset: true"></select>
                           </div>
                           
                           <div class="form-group row">
                               <label class="form-label">Description</label>
                               <input type="text" class="input-text" data-bind="value: description">
                           </div>
                           <div class="form-group">
                               <label class="form-label">Image</label>
                               <div id="dropzone">
                                    <div id="my-drop-zone" class="dropzone needsclick dz-clickable"></div>
                                    <input id="mailing-list-image" data-bind="value: image" type="hidden">
                                </div>
                                <div class="form-note">It is recommended to use square images. Images that are not square will be cropped.</div>
                           </div>
                       </div>
                        <div class="form-footer"> 
                           <button type="button" data-bind="event: { click: onClickCancelMailingList }" class="btn ">Cancel</button>
                           <button type="button" data-bind="event: { click: onClickSaveMailingList }" class="btn highlight">Apply</button>
                        </div>
                   </div>
               </div>
            </div>
        `;
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , idForm: ko.observable("")
            , idFieldToSignupForm: ko.observable(null)
            , indexField: ko.observable(null)
            , fields: ko.observableArray([])
            , availableFields: ko.observable("")
            , selectedField: ko.observable(null)
            , idMailingListToSignupForm: ko.observable(null)
            , indexMailingList: ko.observable(null)
            , mailingLists: ko.observableArray([])
            , availableMailingLists: ko.observable("")
            , selectedMailingList: ko.observable(null)
            , label: ko.observable("")
            , buttonText: ko.observable("")
            , isRequired: ko.observable(false)
            , defaultValue: ko.observable("")
            , isSelected: ko.observable(false)
            , description: ko.observable("")
            , image: ko.observable(null)
            , isAddFieldVisible: ko.observable(null)
            , isAddMailingListVisible: ko.observable(null)
            , menuTitle: ko.observable(null)
            , dropzone: ko.observable(null)
            , isDefaultValueCheckbox: ko.observable(false)
            , onChangeField: function () {
                self.onChangeField()
            },onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();
            },onClickSave: function (data, event) {
                self.onClickSave()
            },onClickAddField: function (data, event) {
                self.onClickAddField()
            },onClickEditField: function (data, event) {
                self.onClickEditField(data, event)
            },onClickDeleteField: function (data, event) {
                self.onClickDeleteField(data, event)
            },onClickCancelField: function (data, event) {
                self.onClickCancelField()
            },onClickSaveField: function (data, event) {
                self.onClickSaveField()
            },onClickAddMailingList: function (data, event) {
                self.onClickAddMailingList()
            },onClickEditMailingList: function (data, event) {
                self.onClickEditMailingList(data, event)
            },onClickDeleteMailingList: function (data, event) {
                self.onClickDeleteMailingList(data, event)
            },onClickCancelMailingList: function (data, event) {
                self.onClickCancelMailingList()
            },onClickSaveMailingList: function (data, event) {
                self.onClickSaveMailingList()
            }
        }
    }

    protected getTemplateName(): string {
        return "signupFormEdit_template";
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }

    public setIdForm(idForm){
        this.getTemplateViewModel().idForm(idForm)
    }

    public setFields(fields){
        for (let field of fields) {
            field.labelID = field.label + " (" + field.idFieldGiven + ")";
        }

        this.getTemplateViewModel().fields(fields)
    }

    public setMailingLists(mailingLists){
        for (let mailingList of mailingLists) {
            mailingList.labelID = mailingList.label + " (" + mailingList.idMailingListGiven + ")";
        }

        this.getTemplateViewModel().mailingLists(mailingLists)
    }

    public setAvailableFields(availableFields){
        for (let field of availableFields) {
            field.labelID = field.label + " (" + field.idField + ")";
        }

        availableFields.sort(function(a,b){
            let a1 = a.label;
            let b1 = b.label;
            return a1.localeCompare(b1);
        });
        this.getTemplateViewModel().availableFields(availableFields)
    }

    public setAvailableMailingLists(availableMailingLists){
        for (let mailingList of availableMailingLists) {
            mailingList.labelID = mailingList.label + " (" + mailingList.idMailingList + ")";
        }

        availableMailingLists.sort(function(a,b){
            let a1 = a.label;
            let b1 = b.label;
            return a1.localeCompare(b1);
        });
        this.getTemplateViewModel().availableMailingLists(availableMailingLists)
    }

    public setLabel(label){
        this.getTemplateViewModel().label(label)
    }

    public setButtonText(buttonText){
        this.getTemplateViewModel().buttonText(buttonText)
    }

    public onChangeField() {
        let selectedField = this.getTemplateViewModel().availableFields().find(e => (e.id == this.getTemplateViewModel().selectedField()));
        if (selectedField.type == "checkbox") {
            this.getTemplateViewModel().isDefaultValueCheckbox(true);
        }
        else {
            this.getTemplateViewModel().isDefaultValueCheckbox(false);
        }
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.getTemplateViewModel().dropzone(null);
        this.caller.save()
    }

    protected onClickAddField(): any {
        this.getTemplateViewModel().isAddFieldVisible(true);
        this.getTemplateViewModel().menuTitle('Add Field');
    }

    protected onClickEditField(data, event): any {
        this.getTemplateViewModel().isAddFieldVisible(true);
        this.getTemplateViewModel().menuTitle('Edit Field');
        this.getTemplateViewModel().idFieldToSignupForm(data.id);
        this.getTemplateViewModel().indexField(ko.contextFor(event.target).$index());
        this.getTemplateViewModel().isRequired(data.isRequired);
        this.getTemplateViewModel().defaultValue(data.defaultValue);

        let selectedField = this.getTemplateViewModel().availableFields().find(e => (e.id == data.idField));
        if(selectedField) {
            this.getTemplateViewModel().selectedField(selectedField.id);
        }

        this.onChangeField();
    }

    protected onClickDeleteField(data, event): any {
        let indexField = ko.contextFor(event.target).$index();
        if (indexField > -1) {
            this.getTemplateViewModel().fields.splice(indexField, 1);
        }
    }

    protected onClickCancelField(): any {
        this.getTemplateViewModel().isAddFieldVisible(false);
        this.getTemplateViewModel().selectedField(null);
        this.getTemplateViewModel().isRequired(false);
        this.getTemplateViewModel().defaultValue("");
        this.getTemplateViewModel().menuTitle(null);
        this.getTemplateViewModel().idFieldToSignupForm(null);
        this.getTemplateViewModel().indexField(null);
    }

    protected onClickSaveField(): any {
        // clone obj
        let selectedField = JSON.parse(JSON.stringify(this.getTemplateViewModel().availableFields().find(e => (e.id == this.getTemplateViewModel().selectedField()))));
        if (!selectedField) {
            throw new Error('Invalid field');
        }

        let idEntity = selectedField.id;
        selectedField.id = this.getTemplateViewModel().idFieldToSignupForm();
        selectedField.idField = idEntity;
        selectedField.idSignupForm = this.getTemplateViewModel().id();
        selectedField.isRequired = this.getTemplateViewModel().isRequired();
        if (this.getTemplateViewModel().isDefaultValueCheckbox()) {
            selectedField.defaultValue = this.getTemplateViewModel().defaultValue() ? true : false;
        }
        else {
            selectedField.defaultValue = this.getTemplateViewModel().defaultValue();
        }

        if(this.getTemplateViewModel().indexField() != null) {
            let indexField = this.getTemplateViewModel().indexField();
            if (indexField > -1) {
                this.getTemplateViewModel().fields.splice(indexField, 1, selectedField);
            }
            else {
                throw new Error('Cannot edit item');
            }
        }
        else {
            this.getTemplateViewModel().fields.push(selectedField);
        }
        this.onClickCancelField();
    }

    protected onClickAddMailingList(): any {
        this.getTemplateViewModel().isAddMailingListVisible(true);
        this.getTemplateViewModel().menuTitle('Add Mailing List');
    }

    protected onClickEditMailingList(data, event): any {
        this.getTemplateViewModel().isAddMailingListVisible(true);
        this.getTemplateViewModel().menuTitle('Edit Mailing List');
        this.getTemplateViewModel().idMailingListToSignupForm(data.id);
        this.getTemplateViewModel().indexMailingList(ko.contextFor(event.target).$index());
        this.getTemplateViewModel().isSelected(data.isSelected);
        this.getTemplateViewModel().description(data.description);
        this.getTemplateViewModel().image(data.image);

        if(this.getTemplateViewModel().image()) {
            let mockFile = {name: this.getTemplateViewModel().image(), size: parseInt("264560")};
            this.getTemplateViewModel().dropzone().emit("addedfile", mockFile);
            this.getTemplateViewModel().dropzone().createThumbnailFromUrl(mockFile, mockFile.name);
            this.getTemplateViewModel().dropzone().emit("complete", mockFile);
            this.getTemplateViewModel().dropzone().files.push(mockFile);
        }

        let selectedMailingList = this.getTemplateViewModel().availableMailingLists().find(e => (e.id == data.idMailingList));
        if(selectedMailingList) {
            this.getTemplateViewModel().selectedMailingList(selectedMailingList.id);
        }
    }

    protected onClickDeleteMailingList(data, event): any {
        let indexMailingList = ko.contextFor(event.target).$index();
        if (indexMailingList > -1) {
            this.getTemplateViewModel().mailingLists.splice(indexMailingList, 1);
        }
    }

    protected onClickCancelMailingList(): any {
        this.getTemplateViewModel().isAddMailingListVisible(false);
        this.getTemplateViewModel().selectedMailingList(null);
        this.getTemplateViewModel().isSelected(false);
        this.getTemplateViewModel().description("");
        this.getTemplateViewModel().image(null);
        this.getTemplateViewModel().menuTitle(null);
        this.getTemplateViewModel().idMailingListToSignupForm(null);
        this.getTemplateViewModel().indexMailingList(null);
        this.getTemplateViewModel().dropzone().removeAllFiles();
    }

    protected onClickSaveMailingList(): any {
        // clone obj
        let selectedMailingList = JSON.parse(JSON.stringify(this.getTemplateViewModel().availableMailingLists().find(e => (e.id == this.getTemplateViewModel().selectedMailingList()))));
        if (!selectedMailingList) {
            throw new Error('Invalid mailing list');
        }

        let idEntity = selectedMailingList.id;
        selectedMailingList.id = this.getTemplateViewModel().idMailingListToSignupForm();
        selectedMailingList.idMailingList = idEntity;
        selectedMailingList.idSignupForm = this.getTemplateViewModel().id();
        selectedMailingList.isSelected = this.getTemplateViewModel().isSelected();
        selectedMailingList.description = this.getTemplateViewModel().description();
        selectedMailingList.image = this.getTemplateViewModel().image();

        if(this.getTemplateViewModel().indexMailingList() != null) {
            let indexMailingList = this.getTemplateViewModel().indexMailingList();
            if (indexMailingList > -1) {
                this.getTemplateViewModel().mailingLists.splice(indexMailingList, 1, selectedMailingList);
            }
            else {
                throw new Error('Cannot edit item');
            }
        }
        else {
            this.getTemplateViewModel().mailingLists.push(selectedMailingList);
        }
        this.onClickCancelMailingList();
    }

    public generateDropzone(idBrand){
        let url = '/api/brand/' + idBrand + '/signupForm/uploadImage/';
        let myDropzone = new Dropzone("div#my-drop-zone", { url: url, maxFiles: 1, acceptedFiles: "image/jpeg,image/png,image/gif"});
        this.getTemplateViewModel().dropzone(myDropzone);
        let _this = this;

        myDropzone.on("success", function(file, serverFileName) {
            let responseParsed = serverFileName;
            _this.getTemplateViewModel().image(responseParsed.data);
        });
        myDropzone.on("addedfile", function(file) {
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/signupFormEdit_template.ts